const AUTH_SESSION_KEY = 'auth-session';
const LOGIN_RECORDED_KEY = 'loginRecorded';

/** 로그인 성공 시 세션 표시용 플래그 (httpOnly 쿠키는 JS에서 읽을 수 없음) */
export const markAuthSession = (): void => {
	localStorage.setItem(AUTH_SESSION_KEY, '1');
};

export const clearAuthSession = (): void => {
	localStorage.removeItem(AUTH_SESSION_KEY);
};

export const hasAuthSession = (): boolean =>
	localStorage.getItem(AUTH_SESSION_KEY) === '1';

/** 세션 플래그 + 구버전 localStorage 토큰 정리 */
export const clearStoredTokens = (): void => {
	localStorage.removeItem('access-token');
	localStorage.removeItem('refresh-token');
	localStorage.removeItem('access-exp');
	localStorage.removeItem('refresh-exp');
	clearAuthSession();
};

/** fetch/axios에 쿠키 포함 */
export const getCredentialsOption = (): RequestCredentials => 'include';

/** 로그인 기록 여부 (sessionStorage - 브라우저 닫으면 자동 삭제) */
export const markLoginRecorded = (): void => {
	sessionStorage.setItem(LOGIN_RECORDED_KEY, '1');
};

export const clearLoginRecorded = (): void => {
	sessionStorage.removeItem(LOGIN_RECORDED_KEY);
};

export const hasLoginRecorded = (): boolean =>
	sessionStorage.getItem(LOGIN_RECORDED_KEY) === '1';
